<template>
  <div>
    <ClientHeader :cid="cid" :sid="sid"/>
    <section class="client-confirm">
      <div class="container">
        <h2 class="client-confirm__title">
        <!-- <i class="material-icons">chevron_left</i> -->
          Ваш выбор
        </h2>
        <div class="client-confirm__wrap">
          <router-link
            class="client-confirm__add-service"
            :to="`/company/${cid}/${sid}/client-service`"
          >
            <i class="material-icons">add</i>Добавить услугу
          </router-link>
          <div class="client-confirm__main">
            <Confirms :cid="cid" :sid="sid" />
          </div>
          <div :class="['client-confirm__aside', {'is-active': orderConfirmed && isMobile}]">
            <div class="client-confirm__mobile-wrap">
              <button
                v-if="hasServices"
                @click="confirmOrder"
                class="client-confirm__confirm-btn js-confirm-order"
                type="button">Подтвердить заказ
              </button>
            </div>
            <!-- Contacts Form -->
            <div :class="['client-confirm-contacts', {'is-active': orderConfirmed}]">
              <div class="client-confirm-contacts__wrap">
                <h2 class="client-confirm-contacts__title">Контактные данные</h2>
                <label for="contacts1" class="client-confirm-contacts__label">Имя и Фамилия</label>
                <input
                  type="text"
                  id="contacts1"
                  class="client-confirm-contacts__input"
                  v-model="fullName"
                >
                <label for="contacts1" class="client-confirm-contacts__label">Телефон</label>
<!--                <input-->
<!--                  type="tel"-->
<!--                  id="contacts2"-->
<!--                  class="client-confirm-contacts__input"-->
<!--                  v-model="phone"-->
<!--                  @input.native="setCustomerPhone"-->
<!--                >-->
                <div class="phone-client" :class="{ 'valid' : phoneNumber.isValid,  'inValid': !phoneNumber.isValid }">
                  <vue-tel-input
                    v-model="phone"
                    inputClasses="phone-input"
                    defaultCountry='ru'
                    placeholder='Введите номер телефона'
                    :dynamicPlaceholder='false'
                    :enabledCountryCode='false'
                    :onlyCountries="['ru', 'ua', 'by']"
                    :validCharactersOnly="true"
                    @validate="onInputNumber"
                    >
                  </vue-tel-input>
                  <i v-if="phoneNumber.isValid" class="material-icons">done</i>
                </div>
                <input
                  type="checkbox"
                  class="client-confirm-contacts__check"
                  id="contacts-check"
                  v-model="confirmedAgreement"
                >
                <label for="contacts-check" class="client-confirm-contacts__check-label">
                  Принимаю
                  <a href="http://croinc.ru/agreement.docx" target="_blank">
                    Соглашение на обработку персональных данных и
                    Пользовательское Соглашение
                  </a>
                </label>
                <!--<label for="contacts1" class="client-confirm-contacts__label">Промо-код</label>-->
                <!--<input type="text" id="contacts3" class="client-confirm-contacts__input">-->
                <!--<button  class="client-confirm-contacts__promo" type="button">Активировать</button>-->
                <!--<a href="https://www.google.com" class="client-confirm__exteranl-link" target="_blank">Example.com</a>-->
                <ul v-if="errors.length" style="color: red">
                  <li
                    v-for="(error, index) in errors"
                    style="display: block; text-align: right"
                    :key="index"
                  >{{error}}</li>
                </ul>
              </div>
              <div class="client-confirm-contacts__end">
                <div class="client-confirm-contacts__summ">
                  Итого:
                  <span>{{finalCost}}₽</span>
                </div>
                <button
                  class="client-confirm-contacts__back-btn js-close-confirm"
                  type="button"
                  @click="backToOrder"
                >Назад</button>
                <button
                  :to="`/company/${cid}/${sid}/client-end`"
                  class="client-confirm-contacts__submit"
                  @click="submitForm"
                  :disabled="disabled"
                >Записаться</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import ClientHeader from "@/components/ClientHeader.vue";
import Confirms from "@/components/Confirms.vue";
import PopularServices from "@/components/PopularServices.vue";

import { mapGetters, mapState, mapMutations, mapActions } from "vuex";
import {isMobileDevice} from "../helpers/osChecker";
export default {
  name: "client-confirm",
  components: {
    ClientHeader,
    Confirms,
    PopularServices
  },
  props: ['sid', 'cid'],
  data() {
    return {
      errors: [],
      requesting: false,
      phoneNumber: {
        number: null,
        isValid: false
      },
      orderConfirmed: false
    };
  },
  methods: {
    ...mapActions("client", ["sentForm"]),
    ...mapMutations("client", [
      "setCustomerName",
      "setCustomerPhone",
      "confirmAgreement"
    ]),

    async submitForm() {
      if (!this.checkForm()) return;
      this.requesting = true;
      const isSuccessful = await this.sentForm();
      this.requesting = false;
      if (isSuccessful) {
        this.$router.push(`/company/${this.cid}/${this.sid}/client-end`);
      } else {
        this.$message.error(this.creatingError, {
          duration: 10000
        });
      }
    },

    checkForm() {
      this.errors = [];

      if (!this.fullName) {
        this.errors.push("Представтесь, пожалуйста");
      }
      if (!this.phone){
        this.errors.push("Укажите номер телефона");
      } else if( !this.phoneNumber.isValid) {
          this.errors.push("Укажите корректный номер телефона");
      }
      if (!this.confirmedAgreement) {
        this.errors.push("Примите условия соглашения");
      }
      if (!this.selectedServices.length) {
        this.errors.push("Выберите услуги");
      }
      return this.errors.length === 0;
    },
    onInputNumber({ number, isValid, country }) {
      this.phoneNumber.number = number;
      this.phoneNumber.isValid = isValid;
      this.setCustomerPhone(number.e164);
    },
    confirmOrder() {
      this.orderConfirmed = true;
    },
    backToOrder() {
      this.orderConfirmed = false;
    }
  },
  computed: {
    ...mapState("client", ["customer", "selectedServices", "companyId", "creatingError"]),
    ...mapGetters("client", ["finalCost"]),
    isMobile() {
      return isMobileDevice();
    },
    hasServices() {
      return this.selectedServices.length;
    },
    fullName: {
      get() {
        return this.customer.fullName;
      },
      set(value) {
        this.setCustomerName(value);
      }
    },
    phone: {
      get() {
        return this.customer.phone;
      },
      set(value) {}
    },
    confirmedAgreement: {
      get() {
        return this.customer.confirmedAgreement;
      },
      set(value) {
        this.confirmAgreement(value);
      }
    },
    disabled: function() {
      if (!this._disabled && !this.requesting) return false;
      return true;
    },
    _disabled: function() {
      return !(
        this.fullName &&
        this.phoneNumber.isValid &&
        this.confirmedAgreement &&
        this.selectedServices.length
      );
    }
  }
};
</script>
<style lang="sass">
// width
=r($width)
  @media only screen and (max-width: $width+ "px")
    @content

=rmin($width)
  @media only screen and (min-width: $width+ "px")
    @content

// height
=rh($height)
  @media only screen and (max-height: $height + "px")
    @content

=rhmin($height)
  @media only screen and (min-height: $height + "px")
    @content
// LAYOUT
$mobile-s: 375
$mobile: 568
$tablet: 767
$desktop: 992
$wide: 1336
$hd: 1440

// COLORS
$text-18: #181818
$text-36: #363636

// OPTIONS
$transitSpeed: .2s
$ease: ease-in-out

.client-confirm
  .vue-tel-input
    border: none
    width: 100%
  .phone-client
    display: flex
    align-items: center
    justify-content: space-between
    width: 100%
    margin: 10px 0 20px
    border: none
    border-bottom: 2px solid #000
    &.valid
      border-color: #42b983
    &.inValid
      border-color: #ff3400
    i
      color: #42b983
  &__title
    font-size: 18px
    font-weight: 400
    margin-top: 0
    margin-bottom: 30px
    color: $text-18
    position: relative
    i
      display: none
      position: absolute
      top: 50%
      left: 0
      transform: translateY(-50%)
  &__wrap
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: stretch
    height: calc(100vh - 190px)
    position: relative
  &__exteranl-link
    margin-top: 10px
    display: block
    text-align: left
    font-weight: bold
    width: 100%
  &__add-service
    position: absolute
    bottom: 0
    left: 0
    font-size: 16px
    font-weight: 400
    text-align: center
    padding: 9px 15px
    border-radius: 8px
    border: 0
    z-index: 5
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: center
    align-items: center
    color: #fff
    background-color: $text-36
    i
      display: none
    &:hover
      cursor: pointer
  &__main
    width: calc(60% - 10px)
    box-shadow: 0px -5px 15px rgba(0,0,0,0.05)
    overflow-y: auto
    position: relative
    z-index: 4
    height: calc(100% - 50px)
  &__item
    position: relative
    padding: 20px
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    background-color: #fff
    &:after
      content: ''
      position: absolute
      bottom: 0
      left: 0
      width: 100%
      height: 1px
      background-image: linear-gradient(to right, transparent 0%, transparentize($text-36, 0.6) , transparent 100%)
  &__service
    width: 48%
    &-title
      font-size: 16px
      margin-top: 0
      margin-bottom: 20px
      font-weight: 600
      color: #4D4D4D
    &-name
      color: #4D4D4D
      font-size: 18px
      font-weight: 400
      margin-top: 0
      margin-bottom: 10px
      padding-left: 20px
  &__type
    color: #4D4D4D
    font-size: 16px
    margin-bottom: 20px
    margin-top: 0
    font-weight: 400
    padding-left: 20px
  &__param
    font-size: 14px
    color: #4D4D4D
    margin-top: 0
    margin-bottom: 8px
    font-weight: 500
    padding-left: 20px
  &__master
    width: 48%
    &-title
      font-size: 16px
      margin-top: 0
      margin-bottom: 20px
      font-weight: 600
      color: $text-18
    &-wrap
      display: -webkit-flex
      display: -ms-flex
      display: flex
      justify-content: flex-start
      align-items: flex-start
      margin-bottom: 35px
      padding-left: 20px
  &__img
    flex: 0 0 auto
    width: 50px
    height: 50px
    border-radius: 50%
    margin-right: 10px
  &__master-info
    flex-grow: 1
  &__name
    font-size: 18px
    margin-top: 0
    margin-bottom: 10px
    font-weight: 400
    color: #4D4D4D
  &__time
    font-size: 16px
    font-weight: 400
    color: #4D4D4D
    margin: 0
  &__buttons
    display: -webkit-flex
    display: -ms-flex
    display: flex
    align-items: stretch
    justify-content: flex-end
    width: 100%
  &__edit
    padding: 9px 15px
    text-align: center
    font-size: 16px
    border-radius: 8px
    border: 0
    color: #fff
    background-color: $text-36
    &:hover
      cursor: pointer
  &__delete
    padding: 9px 15px
    background-color: #fff
    color: $text-18
    margin-left: 15px
    border: 0
    &:hover
      cursor: pointer
  &__aside
    width: calc(40% - 10px)
    display: -webkit-flex
    display: -ms-flex
    display: flex
    flex-direction: column
    align-items: flex-end
    position: relative
    z-index: 3
    .client-service-aside__wrap
      width: 100%
  &__confirm-btn
    padding: 9px 15px
    text-align: center
    font-size: 16px
    border-radius: 8px
    border: 0
    color: #fff
    background-color: $text-36
    margin-top: auto
    &:hover
      cursor: pointer
  &__mobile-wrap
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: flex-end
    align-items: center
    margin-top: auto
    width: 100%
    min-width: 290px
    .client-confirm-contacts__summ
      display: none
//Contacts Form
.client-confirm-contacts
  position: absolute
  top: 0
  right: 0
  width: calc(100% + 20px)
  //min-width: 320px
  height: 100%
  display: -webkit-flex
  display: -ms-flex
  display: flex
  align-items: flex-start
  flex-direction: column
  background-color: #fff
  z-index: 2
  transition: all $transitSpeed
  transform: translateX(-50px)
  opacity: 0
  visibility: hidden
  &.is-active
    opacity: 1
    visibility: visible
    transform: translateX(0)
  &__wrap
    padding: 30px
    display: -webkit-flex
    display: -ms-flex
    display: flex
    flex-direction: column
    align-items: flex-end
    box-shadow: 3px 0px 15px rgba(0,0,0,0.1)
    height: calc(100% - 60px)
    background-color: #fff
  &__title
    font-size: 16px
    margin-top: 0
    margin-bottom: 20px
    font-weight: 600
    color: #4D4D4D
    width: 100%
  &__label
    display: block
    width: 100%
    font-size: 14px
    color: #4D4D4D
    margin-top: 0
    margin-bottom: 10px
    padding-left: 20px
  &__input
    display: block
    width: 100%
    padding: 9px 20px
    font-size: 16px
    color: #4D4D4D
    margin-bottom: 15px
    border: 0
    border-bottom: 1px solid $text-36
  &__check
    display: none
    &:checked + label
      &:before
        content: ''
        position: absolute
        top: 0
        left: 0
        width: 24px
        height: 24px
        background-color: #fff
        border: 1px solid $text-36
        background-repeat: no-repeat
        background-size: 70% 70%
        background-position: 50% 50%
        border-radius: 8px
        background-image: url(../assets/img/check.svg)
  &__check-label
    font-size: 14px
    font-weight: 500
    color: #4D4D4D
    position: relative
    padding-left: 35px
    margin-bottom: 20px
    width: 100%
    display: block
    &:before
      content: ''
      position: absolute
      top: 0
      left: 0
      width: 24px
      height: 24px
      background-color: #fff
      border: 1px solid $text-36
      background-repeat: no-repeat
      background-size: 70% 70%
      background-position: 50% 50%
      border-radius: 8px
    &:hover
      cursor: pointer
    a
      text-decoration: underline
  &__promo
    padding: 9px 15px
    text-align: center
    font-size: 16px
    border-radius: 8px
    border: 0
    color: #fff
    background-color: $text-36
    &:hover
      cursor: pointer
  &__submit
    padding: 9px 15px
    text-align: center
    font-size: 16px
    border-radius: 8px
    border: 0
    color: #fff
    background-color: $text-36
    &:hover
      cursor: pointer
    &[disabled]
      background-color: gray
      cursor: not-allowed
  &__end
    margin-top: auto
    padding: 15px 0 5px 20px
    display: -webkit-flex
    display: -ms-flex
    display: flex
    justify-content: space-between
    align-items: center
    width: 100%
  &__back-btn
    display: block
    font-size: 16px
    color: $text-36
    margin-right: 10px
    background-color: transparent
    padding: 0
    border: 0
    &:hover
      cursor: pointer
  &__summ
    font-size: 15px
    font-weight: 400
    margin-right: auto
    span
      display: block
      font-weight: 500
+rmin($desktop)
  .client-confirm
    &__wrap
      min-height: 394px

+r($desktop)
  .client-confirm
    &__wrap
      height: calc(100vh - 140px)
    &__add-service
      font-size: 14px
    &__type
      padding-left: 0
      font-size: 14px
    &__param
      padding-left: 0
    &__service-name
      padding-left: 0
      font-size: 14px
    &__master-wrap
      padding-left: 0
    &__name
      font-size: 14px
    &__time
      font-size: 14px
    &__edit,
    &__delete
      font-size: 14px
      padding: 7px 13px

  .client-confirm-contacts
    &__wrap
    padding: 20px

+r($tablet)
  .client-confirm
    &__item
      padding: 15px 20px
      flex-direction: column
      margin-bottom: 10px
    &__service
      width: 100%
    &__master
      width: 100%
      margin-top: 25px
    &__title,
    &__master-title
      margin-bottom: 17px
    &__aside
      width: calc(45% - 10px)
      .client-service-aside__wrap
        display: none
    &__main
      width: calc(55% - 10px)
      & > div
        width: 100%

  .client-confirm-contacts
    &__label
      margin-bottom: 7px
    &__input
      padding: 7px 20px
    &__promo,
    &__submit,
    &__confirm-btn,
    &__back-btn
      font-size: 14px
    &__submit
      padding: 9px 10px
    &__wrap
      height: calc(100% - 50px)
      padding: 20px 10px
    &__end
      padding-left: 10px

+r($mobile)
  .client-confirm
    border-top-left-radius: 14px
    border-top-right-radius: 14px
    box-shadow: 0px -5px 15px rgba(0,0,0,0.05)
    padding-top: 20px
    & > .container
      padding-left: 23px
      padding-right: 23px
    &__title
      width: calc(100% - 14px)
      padding-left: 25px
      margin-left: auto
      margin-right: auto

      i
        display: inline-block
    &__add-service
      font-size: 12px
      padding: 5px
      left: unset
      bottom: calc(100% + 10px)
      right: 0
      i
        display: inline-block
        font-size: 17px
    &__main
      width: 100%
      display: flex
      flex-direction: row
      box-shadow: none
      overflow-x: visible
      overflow-y: auto
      padding: 10px 7px
      margin-left: -0px
      margin-right: -0px
      height: calc(100% - 60px)
    &__item
      border-radius: 8px
      box-shadow: 0 0 15px rgba(0,0,0,0.1)
      min-width: 265px
      width: 100%
      margin-left: auto
      margin-right: auto
      flex: 0 0 auto
      &:last-child
        margin-right: 0
      &:after
        display: none
    &__wrap
      box-shadow: none
      height: calc(100vh - 248px)
    &__aside
      width: 100%
      position: absolute
      top: 0
      left: 0
      height: 100%
      &.is-active
        z-index: 5
    &__mobile-wrap
      // justify-content: space-between
      .client-confirm-contacts__summ
        display: block

  .client-confirm-contacts
    transform: translateX(50px)
    width: calc(100% + 30px)
    height: calc(100% + 42px)
    margin-left: -15px
    margin-right: -15px
    padding: 0 15px
    top: -40px
    &__wrap
      box-shadow: none
      padding: 0



</style>
